// extracted by mini-css-extract-plugin
export default {"main":"MainLayout_main__tn+Z3"};